import { AppState, useAppSelector } from "../store";

export const usePermissionWrapper = () => {
  const  allUIpermissions:any  = useAppSelector((state:AppState)=>state.commonSlice.permissions);

  const checkPermission = (permission: string) => {
    const found = allUIpermissions?.find((item:any)=>item==permission)
    return (found?.length>0 || permission=='true') ? true : false 
  };
  return { checkPermission };
};
